export const Skeleton = ({ className }: { className?: string }) => (
  <div
    className={`relative overflow-hidden rounded-xl bg-app-surface-muted ${className ?? ""}`}
  >
    <span className="absolute inset-y-0 left-0 w-1/2 animate-shimmer bg-gradient-to-r from-transparent via-white/20 to-transparent" />
  </div>
);
